<table
  mat-table
  class="approvals-table"
  [dataSource]="approvalItems"
  multiTemplateDataRows>
  <ng-container matColumnDef="indicator">
    <th mat-header-cell *matHeaderCellDef=""></th>
    <td mat-cell *matCellDef="let item">
      @if (readOnly) {
        <button
          mat-icon-button
          (click)="openApprovalDialog(item.approval.consent_request_id)">
          <consent-approval-indicator
          [indicatorState]="item.indicator"></consent-approval-indicator>
        </button>
      }
      @if (!readOnly) {
        <consent-approval-indicator
        [indicatorState]="item.indicator"></consent-approval-indicator>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="fund">
    <th mat-header-cell *matHeaderCellDef="">Fund</th>
    <td mat-cell *matCellDef="let item">
      <contact-link [subject]="item.fund"></contact-link>
    </td>
  </ng-container>
  <ng-container matColumnDef="consent_required">
    <th mat-header-cell *matHeaderCellDef="">Consent Required</th>
    <td mat-cell *matCellDef="let item">
      @if (
        !readOnly &&
        (permission | permission: '_edit':'consent_required_status_id')
        ) {
        <mat-form-field
          >
          <mat-label>Consent Required</mat-label>
          <mat-select [(ngModel)]="item.consent_required" (ngModelChange)="approvalRequiredChange($event, item)">
            <mat-option>&mdash;</mat-option>
            @for (status of statuses; track status) {
              <mat-option [value]="status">{{
                status.required_status
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (
        readOnly ||
        !(permission | permission: '_edit':'consent_required_status_id')
        ) {
        <span
          >
          {{
          item.consent_required
          ? item.consent_required.required_status
          : "\u2014"
          }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="sent_date">
    <th mat-header-cell *matHeaderCellDef="">Sent to Investors</th>
    <td mat-cell *matCellDef="let item">
      @if (
        !readOnly && (permission | permission: '_edit':'investor_sent_date')
        ) {
        <mat-form-field
          >
          <mat-label>Sent To Investors</mat-label>
          <input
            matInput
            [matDatepicker]="sent_date"
            [(ngModel)]="item.sent_date" />
          <mat-datepicker-toggle
            matIconSuffix
          [for]="sent_date"></mat-datepicker-toggle>
          <mat-datepicker #sent_date></mat-datepicker>
        </mat-form-field>
      }
      @if (
        readOnly || !(permission | permission: '_edit':'investor_sent_date')
        ) {
        <span
          >
          {{ item.sent_date ? (item.sent_date | date: "MM/dd/yyyy") : "\u2014" }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="percent_required">
    <th mat-header-cell *matHeaderCellDef>% Approval Required</th>
    <td mat-cell *matCellDef="let item">
      @if (
        !readOnly &&
        (permission | permission: '_edit':'percent_approval_required')
        ) {
        <mat-form-field
          >
          <mat-label>Approval Required</mat-label>
          <input matInput type="number" [(ngModel)]="item.percent_required" />
          <mat-icon matIconSuffix>percent</mat-icon>
        </mat-form-field>
      }
      @if (
        readOnly ||
        !(permission | permission: '_edit':'percent_approval_required')
        ) {
        <span
          >
          {{
          item.percent_required
          ? (item.percent_required / 100 | percent: "1.2-2")
          : "\u2014"
          }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="current_percent">
    <th mat-header-cell *matHeaderCellDef>Current % Approved</th>
    <td mat-cell *matCellDef="let item">
      <span>
        {{
        item.current_percent
        ? (item.current_percent | percent: "1.2-2")
        : "\u2014"
        }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="fund_approval_date">
    <th mat-header-cell *matHeaderCellDef="">Fund Approved Date</th>
    <td mat-cell *matCellDef="let item">
      @if (
        !readOnly && (permission | permission: '_edit':'fund_approval_date')
        ) {
        <mat-form-field
          >
          <mat-label>Fund Approved Date</mat-label>
          <input
            matInput
            [matDatepicker]="sent_date"
            [(ngModel)]="item.fund_approval_date" />
          <mat-datepicker-toggle
            matIconSuffix
          [for]="sent_date"></mat-datepicker-toggle>
          <mat-datepicker #sent_date></mat-datepicker>
        </mat-form-field>
      }
      @if (
        readOnly || !(permission | permission: '_edit':'fund_approval_date')
        ) {
        <span
          >
          {{
          item.fund_approval_date
          ? (item.fund_approval_date | date: "MM/dd/yyyy")
          : "\u2014"
          }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="investor_report_comment">
    <td
      class="investor-report"
      mat-cell
      *matCellDef="let item"
      [attr.colspan]="columns.length">
      <span class="report-label">Investor Report Comment</span>
      @if (
        !readOnly &&
        (permission | permission: '_edit':'investor_report_comment')
        ) {
        <mat-form-field
          >
          <textarea
            matInput
            [(ngModel)]="item.investor_report_comment"
            cdkTextareaAutosize
            style="resize: none; width: 100%">
          </textarea>
        </mat-form-field>
      }
      @if (
        readOnly ||
        !(permission | permission: '_edit':'investor_report_comment')
        ) {
        <span
          >
          {{ item.investor_report_comment }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="investor_approvals">
    <td
      mat-cell
      *matCellDef="let item"
      [attr.colspan]="columns.length"
      class="investor-approvals-cell">
      <consent-investor-approvals-table
        [investorApprovals]="item.investorApprovals"
        [readOnly]="readOnly"
        [permission]="permission"
        [approvalStatuses]="approvalStatuses">
      </consent-investor-approvals-table>
    </td>
  </ng-container>
  <ng-container matColumnDef="expander">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <button mat-icon-button (click)="item.expanded = !item.expanded">
        <mat-icon
          [class]="{
            expander: true,
            expanded: item.expanded
          }">
          keyboard_arrow_down
        </mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" class="main-row"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: subTable"
    [class]="{
      report: true,
      collapsing: true,
      expanded: row.expanded
    }"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: subTable1"
    [class]="{
      investors: true,
      collapsing: true,
      expanded: row.expanded
    }"></tr>
</table>
